export const stringInject = (
  str: string,
  arr: string[] | undefined
): string => {
  if (typeof str !== "string") {
    console.error(str, " is not a string!");
    return "";
  }

  if (!(arr instanceof Array)) {
    console.error(arr, " is not an array!");
    return str;
  }

  return str.replace(/({\d})/g, (i: string) => {
    const index = parseInt(i.replace(/{/, "").replace(/}/, ""));
    return arr[index];
  });
};
